import { Box } from "@chakra-ui/react";
import TicketsPerBranchTable from "../../tables/daily/TicketsPerBranchTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../../store/reportEnterpriseInsights";

const OrganizationTicketsPerBranch = ({ reportIndex, data, renderConfig }) => {
  const insights = buildTicketVolumeInsights(data, { scopeLabel: "Branch" });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Daily Branch Ticket Distribution Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      {data.map((branchData, index) => {
        return (
          <>
            <Box className="reportContainer" mt="20px">
              <TicketsPerBranchTable
                index={index}
                branchData={branchData}
                reportIndex={reportIndex}
                renderConfig={renderConfig}
              />
            </Box>
          </>
        );
      })}
    </Box>
  );
};

export default OrganizationTicketsPerBranch;
